import Announcment from '@admin/components/announcement'
import Scrollbar from '@admin/components/scrollbar'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

class Canvas extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    network: PropTypes.object,
    provider: PropTypes.object
  }

  static propTypes = {
    announcement: PropTypes.object
  }


  render() {
    return (
      <Scrollbar { ...this._getScrollbar() }>
        <Announcment { ...this._getAnnouncment() } />
      </Scrollbar>
    )
  }

  _getScrollbar() {
    return {
      className: 'maha-announcement-designer-canvas',
      hideScroll: true
    }
  }

  _getAnnouncment() {
    const { announcement } = this.props
    const { provider } = this.context
    return {
      announcement: {
        provider: {
          title: provider.title,
          logo: provider.logo
        },
        ...announcement
      }
    }
  }


}

export default Canvas
